import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { useInsuranceLines } from '@services/insuranceLine/useInsuranceLines';
import { useMemo } from 'react';

export interface InsuranceLineTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const InsuranceLineTypeaheadFilter = (componentProps: InsuranceLineTypeaheadFilterProps) => {
  const { insuranceLines } = useInsuranceLines({ sort: '+name', pageLimit: 30 });

  const { value, disabled } = componentProps;

  const options = useMemo(() => {
    return (
      insuranceLines?.items.map((insuranceLine) => ({
        key: insuranceLine.id,
        label: insuranceLine.name,
        value: insuranceLine.id,
      })) ?? []
    );
  }, [insuranceLines]);

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
